<div mat-dialog-title class="u-borderBottom-grey100">
  {{ data?.account?.full_name }}
</div>
<div mat-dialog-content class="u-borderBottom-grey100">
  <form [formGroup]="accountForm" class="u-paddingTop-24">
    <ng-container *ngIf="accountForm.get('first_name') as control">
      <mat-form-field class="mat-form-field-width-100 u-marginBottom-8">
        <mat-label i18n="@@accountEditDialog.firstName">First name</mat-label>
        <input formControlName="first_name" matInput autocomplete="off" />
        <mat-error *ngIf="!!control.getError('server')">
          {{ control.getError('server') }}
        </mat-error>
      </mat-form-field>
      <ng-container
        *ngIf="shouldShowSave(control, data?.account?.first_name)"
        [ngTemplateOutlet]="accountEditField"
        [ngTemplateOutletContext]="{
          control: control,
          fieldName: 'first_name',
        }"
      ></ng-container>
    </ng-container>
    <ng-container *ngIf="accountForm.get('last_name') as control">
      <mat-form-field class="mat-form-field-width-100 u-marginBottom-8">
        <mat-label i18n="@@accountEditDialog.lastName">Last name</mat-label>
        <input formControlName="last_name" matInput autocomplete="off" />
        <mat-error *ngIf="!!control.getError('server')">
          {{ control.getError('server') }}
        </mat-error>
      </mat-form-field>
      <ng-container
        *ngIf="shouldShowSave(control, data?.account?.last_name)"
        [ngTemplateOutlet]="accountEditField"
        [ngTemplateOutletContext]="{
          control: control,
          fieldName: 'last_name',
        }"
      ></ng-container>
    </ng-container>
    <ng-container *ngIf="accountForm.get('email') as control">
      <mat-form-field class="mat-form-field-width-100 u-marginBottom-8">
        <mat-label i18n="@@global.email">Email</mat-label>
        <input formControlName="email" matInput autocomplete="off" />
        <mat-error *ngIf="!!control.getError('server')">
          {{ control.getError('server') }}
        </mat-error>
      </mat-form-field>
      <ng-container
        *ngIf="shouldShowSave(control, data?.account?.email)"
        [ngTemplateOutlet]="accountEditField"
        [ngTemplateOutletContext]="{
          control: control,
          fieldName: 'email',
        }"
      ></ng-container>
    </ng-container>
    <div formArrayName="experience">
      <div [formGroupName]="0">
        <ng-container
          *ngIf="accountForm.get(['experience', '0', 'job_title']) as control"
        >
          <mat-form-field class="mat-form-field-width-100 u-marginBottom-8">
            <mat-label i18n="@@accountEditDialog.jobTitle">Job title</mat-label>
            <input formControlName="job_title" matInput autocomplete="off" />
            <mat-error *ngIf="!!control.getError('server')">
              {{ control.getError('server') }}
            </mat-error>
          </mat-form-field>
          <ng-container
            *ngIf="
              shouldShowSave(
                control,
                data?.account?.experience &&
                  data?.account?.experience?.[0]?.job_title
              )
            "
            [ngTemplateOutlet]="accountSubDocumentEditField"
            [ngTemplateOutletContext]="{
              control: control,
              fieldName: 'job_title',
              rootField: 'experience',
            }"
          ></ng-container>
        </ng-container>
        <ng-container
          *ngIf="
            accountForm.get(['experience', '0', 'organization_name']) as control
          "
        >
          <mat-form-field class="mat-form-field-width-100 u-marginBottom-8">
            <mat-label i18n="@@accountEditDialog.organizationName"
              >Organization name</mat-label
            >
            <input
              formControlName="organization_name"
              matInput
              autocomplete="off"
            />
            <mat-error *ngIf="!!control.getError('server')">
              {{ control.getError('server') }}
            </mat-error>
          </mat-form-field>
          <ng-container
            *ngIf="
              shouldShowSave(
                control,
                data?.account?.experience &&
                  data?.account?.experience?.[0]?.organization_name
              )
            "
            [ngTemplateOutlet]="accountSubDocumentEditField"
            [ngTemplateOutletContext]="{
              control: control,
              fieldName: 'organization_name',
              rootField: 'experience',
            }"
          ></ng-container>
        </ng-container>
      </div>
    </div>
    <div formArrayName="education">
      <div [formGroupName]="0">
        <ng-container
          *ngIf="accountForm.get(['education', '0', 'program']) as control"
        >
          <mat-form-field class="mat-form-field-width-100 u-marginBottom-8">
            <mat-label i18n="@@accountEditDialog.program">Program</mat-label>
            <input formControlName="program" matInput autocomplete="off" />
            <mat-error *ngIf="!!control.getError('server')">
              {{ control.getError('server') }}
            </mat-error>
          </mat-form-field>
          <ng-container
            *ngIf="
              shouldShowSave(
                control,
                data?.account?.education &&
                  data?.account?.education?.[0]?.program
              )
            "
            [ngTemplateOutlet]="accountSubDocumentEditField"
            [ngTemplateOutletContext]="{
              control: control,
              fieldName: 'program',
              rootField: 'education',
            }"
          ></ng-container>
        </ng-container>
        <ng-container
          *ngIf="accountForm.get(['education', '0', 'school']) as control"
        >
          <mat-form-field class="mat-form-field-width-100 u-marginBottom-8">
            <mat-label i18n="@@accountEditDialog.school">School</mat-label>
            <input formControlName="school" matInput autocomplete="off" />
            <mat-error *ngIf="!!control.getError('server')">
              {{ control.getError('server') }}
            </mat-error>
          </mat-form-field>
          <ng-container
            *ngIf="
              shouldShowSave(
                control,
                data?.account?.education &&
                  data?.account?.education?.[0]?.school
              )
            "
            [ngTemplateOutlet]="accountSubDocumentEditField"
            [ngTemplateOutletContext]="{
              control: control,
              fieldName: 'school',
              rootField: 'education',
            }"
          ></ng-container>
        </ng-container>
      </div>
    </div>
    <ng-container *ngIf="accountForm.get('about') as control">
      <mat-form-field class="mat-form-field-width-100 u-marginBottom-8">
        <mat-label i18n="@@accountEditDialog.about">About</mat-label>
        <textarea
          formControlName="about"
          matInput
          cdkTextareaAutosize
          [cdkAutosizeMinRows]="3"
        >
        </textarea>
        <mat-error *ngIf="!!control.getError('server')">
          {{ control.getError('server') }}
        </mat-error>
      </mat-form-field>
      <ng-container
        *ngIf="shouldShowSave(control, data?.account?.about)"
        [ngTemplateOutlet]="accountEditField"
        [ngTemplateOutletContext]="{
          control: control,
          fieldName: 'about',
        }"
      ></ng-container>
    </ng-container>
    <ng-container *ngIf="accountForm.get('website') as control">
      <mat-form-field class="mat-form-field-width-100 u-marginBottom-8">
        <mat-label i18n="@@accountEditDialog.website">Website</mat-label>
        <input formControlName="website" matInput autocomplete="off" />
        <mat-error *ngIf="!!control.getError('server')">
          {{ control.getError('server') }}
        </mat-error>
      </mat-form-field>
      <ng-container
        *ngIf="shouldShowSave(control, data?.account?.website)"
        [ngTemplateOutlet]="accountEditField"
        [ngTemplateOutletContext]="{
          control: control,
          fieldName: 'website',
        }"
      ></ng-container>
    </ng-container>
  </form>
</div>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <div class="u-padding-0-16">
    <button
      mat-button
      color="primary"
      type="button"
      mat-dialog-close
      i18n="@@global.done"
    >
      Done
    </button>
  </div>
</mat-dialog-actions>
<ng-template #accountEditField let-control="control" let-fieldName="fieldName">
  <div fxLayout="row" fxLayoutAlign="end center" class="u-marginBottom-24">
    <button
      mat-button
      color="primary"
      type="button"
      (click)="updateAccount(fieldName, control)"
      [disabled]="!control.valid"
    >
      <span i18n="@@global.saveChanges">Save changes</span>
      <i
        *ngIf="!!fieldsSavingTracker[fieldName]"
        nz-icon
        nzType="sync"
        nzTheme="outline"
        nzSpin
        class="u-marginLeft-8"
      ></i>
    </button>
  </div>
</ng-template>
<ng-template
  #accountSubDocumentEditField
  let-control="control"
  let-fieldName="fieldName"
  let-rootField="rootField"
>
  <div fxLayout="row" fxLayoutAlign="end center" class="u-marginBottom-24">
    <button
      mat-button
      color="primary"
      type="button"
      (click)="
        updateAccountSubDocument(
          fieldName,
          rootField,
          accountForm.get([rootField, '0', '_id']).value,
          control
        )
      "
      [disabled]="!control.valid"
    >
      <span i18n="@@global.saveChanges">Save changes</span>
      <i
        *ngIf="!!fieldsSavingTracker[fieldName]"
        nz-icon
        nzType="sync"
        nzTheme="outline"
        nzSpin
        class="u-marginLeft-8"
      ></i>
    </button>
  </div>
</ng-template>
